module.exports = __webpack_public_path__ + "static/media/cart.bb0f9b50.png";